import { FloatButton } from "antd";
import { useChatContext } from "../context";
import WhistleIcon from "./WhistleIcon";

interface FloatingChatFabProps {
  open: boolean;
  onToggle: () => void;
}

const FloatingChatFab: React.FC<FloatingChatFabProps> = ({ open, onToggle }) => {
  const { isTyping } = useChatContext();
  const showDot = isTyping && !open;

  return (
    <FloatButton
      className="floating-chat-fab"
      icon={<WhistleIcon />}
      tooltip="Whistle AI"
      onClick={onToggle}
      aria-expanded={open}
      badge={showDot ? { dot: true } : undefined}
      // Same 50px circle and right edge as .help-button. styles.css sets the
      // vertical slot, because it depends on whether a help button renders.
      style={{ right: 25 }}
    />
  );
};

export default FloatingChatFab;
